(function() {
    'use strict';
    
    function initContactPopup() {
        const floatingBtn = document.getElementById('floatingContactBtn');
        const popupOverlay = document.getElementById('contactPopupOverlay');
        const closeBtn = document.getElementById('closePopup');
        
        console.log('Initializing contact popup...');
        console.log('Floating button:', floatingBtn);
        console.log('Popup overlay:', popupOverlay);
        console.log('Close button:', closeBtn);
        
        if (!floatingBtn || !popupOverlay || !closeBtn) {
            console.error('Contact popup elements not found');
            return;
        }
        
        // Open popup when floating button is clicked
        floatingBtn.addEventListener('click', function(e) {
            e.preventDefault();
            console.log('Floating button clicked');
            popupOverlay.classList.add('active');
            document.body.style.overflow = 'hidden';
        });
        
        // Close popup when close button is clicked
        closeBtn.addEventListener('click', function(e) {
            e.preventDefault();
            console.log('Close button clicked');
            popupOverlay.classList.remove('active');
            document.body.style.overflow = 'auto';
        });
        
        // Close popup when clicking outside the modal
        popupOverlay.addEventListener('click', function(e) {
            if (e.target === popupOverlay) {
                console.log('Clicked outside modal');
                popupOverlay.classList.remove('active');
                document.body.style.overflow = 'auto';
            }
        });
        
        // Close popup with Escape key
 
        
        console.log('Contact popup initialized successfully');
    }
    
    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initContactPopup);
    } else {
        initContactPopup();
    }
})();
